import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import LabelWithInput from "@components/input/LabelWithInput";
import FadeInContainer from "@components/motion/FadeInContainer";
import { useFormContext } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import { useApiRequest } from "@utils/ApiRequest";
import { CategoryDropdownInput } from "@pages/register/_components/index";

const CategoryInput = ({ custom }: { custom?: boolean }) => {
  const [focusName, setFocusName] = useState<string>("");
  const { getCategoryList } = useApiRequest();
  const { watch, trigger } = useFormContext();

  const depth1 = watch("depth1");

  // console.log("depth1", depth1);
  useEffect(() => {
    if (depth1) {
      trigger("depth1");
    }
  }, [depth1, trigger]);

  // depth1 카테고리 불러오기
  const { data: depth1List } = useQuery({
    queryKey: ["depth1List"],
    queryFn: () => getCategoryList(),
  });

  const { data: depth2List } = useQuery({
    queryKey: ["depth2List", depth1],
    queryFn: () => getCategoryList(depth1),
    enabled: !!depth1,
  });

  return (
    <Container>
      {/* depth1 카테고리 */}

      {custom ? null : <LabelWithInput label="카테고리" required />}
      <CategoryDropdownInput
        focusName={focusName}
        setFocusName={setFocusName}
        options={depth1List || []}
        name="depth1"
      />

      {/* depth2 카테고리 */}
      <FadeInContainer isShow={!!depth1}>
        <CategoryDropdownInput
          focusName={focusName}
          setFocusName={setFocusName}
          options={depth2List || []}
          name="depth2"
        />
      </FadeInContainer>
    </Container>
  );
};

export default CategoryInput;

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
});
